import generateStorageApi from 'easy-storage-manager';

const APP_NAME = 'invoice';

// 发票列表 
const invoiceList = generateStorageApi({
    engine: window.localStorage,
    space: APP_NAME,
    key: 'INVOICE_LIST',
    validate: 'array',
});

const Storage = {
    invoiceList,
};

export default Storage;